module.exports = __webpack_public_path__ + "d149cc99cbb7de797cc3200dbaaf7c7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing/big_photo.jpg
// module id = 1156
// module chunks = 0